module.exports = __webpack_public_path__ + "img/sub.79f0948a.svg";